module.exports = __webpack_public_path__ + "static/media/Marco_Schäfer.cb9b6fe7.jpg";